// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"0b0b66c2","176":"37e26a2e","290":"284da746","319":"e4a75e70","328":"36e7f7a9","645":"66efc7e4","679":"4f5d11c4","885":"6fb73fce","915":"87bdc53e"}[chunkId] + ".chunk.js";
};